import * as React from "react"
import { HeadProps } from "gatsby"
import docsSidebar from "../../components/sidebar/all-docs-sidebar.yaml"
import config from "../../config"

const items = docsSidebar[0].subItems

const findName = pathname => (acc, item) => {
  if (acc) return acc

  if (item.to === pathname) {
    // rename "Overview" label
    if (item.to === "/docs/") return "Documentation"
    return item.label
  }
  if (item.subItems?.length) {
    return item.subItems.reduce(findName(pathname), null)
  }
  return null
}

// breadcrumbs for ld+json structured data
// https://developers.google.com/search/docs/advanced/structured-data/breadcrumb
export default function StructuredData(props: HeadProps) {
  const parts = props.location.pathname.split("/").filter(Boolean)
  const itemListElement = parts.reduce((acc, part, i) => {
    const pathname = "/" + parts.slice(0, i + 1).join("/") + "/"
    const name = items.reduce(findName(pathname), null)
    return [
      ...acc,
      {
        "@type": "ListItem",
        item: config.url + pathname,
        position: i + 1,
        name,
      },
    ]
  }, [])

  const json = JSON.stringify({
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    name: "Gatsby Docs",
    itemListElement,
  })

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{
        __html: json,
      }}
    />
  )
}
